import { createAsyncThunk } from "@reduxjs/toolkit";
import { ApiAction } from "../../../api/ApiAction";
import { endpoints } from "../../../api/endpoints";
import { ITourFilter } from "../../../api/types/directory/ITourFilter";
import { AppDispatch } from "../../appDispatch";
import { RootState } from "../../rootState";
import { IAssociateParams } from "./types/IAssociateParams";

export const fetchAssociateTourFilters = createAsyncThunk<
  ITourFilter[],
  IAssociateParams,
  { state: RootState; dispatch: AppDispatch }
>("associate/tourFilters", async (params, thunkAPI) => {
  const result = await endpoints.directory.get(
    {
      action: ApiAction.getTourFilters,
      operator: params.operator,
      country: params.country,
    },
    thunkAPI.signal,
  );

  return result as ITourFilter[];
});
